import CONSTANTS from '../constants';
import { alerts } from './alerts';
import AppointmentService from '../services/appointmentService';
import CacheService from '../services/cacheService';

export function createAppointment(params, history = {}) {
    return dispatch => {
        dispatch({type: CONSTANTS.ACTIONS.SPINNER.SHOW});
        AppointmentService.createAppointment(params).then((response) => {
            dispatch({type: CONSTANTS.ACTIONS.SPINNER.HIDE});
            if(response.data.success) {
                dispatch(appointmentAction(response.data.appointment));
                dispatch(alerts.success('Appointment created successfully. A confirmation email has been sent'));
            } else if(parseInt(response.data.code, 10) === CONSTANTS.ERRORS.NO_MEMBERSHIP) {
                CacheService.setAppointment(params);
                history.push(`/${CacheService.getToken().bname}/pos/sales`);
            } else {
                dispatch(alerts.error(response.data.message));
            }
        }).catch((error) => {
            dispatch({type: CONSTANTS.ACTIONS.SPINNER.HIDE});
            dispatch(alerts.error(error.message));
        });
    };

    function appointmentAction(appointment) { return {type: CONSTANTS.ACTIONS.APPOINTMENT.CREATE, appointment: appointment} }
}

export function clearAppointment() {
    return dispatch => {
        dispatch({type: CONSTANTS.ACTIONS.APPOINTMENT.CREATE, appointment: null});
    };
}

export function fetchAppointment(id) {
    return dispatch => {
        AppointmentService.getAppointment(id).then((response) => {
            dispatch(appointmentAction(response.data));
        }).catch((error) => {
            dispatch(alerts.error(error.message));
        });
    };

    function appointmentAction(appointment) { return {type: CONSTANTS.ACTIONS.APPOINTMENT.GET.APPOINTMENT, appointment: appointment} }
}

export function fetchAppointments(params) {
    return dispatch => {
        // Reset appointments to null so that component re renders itself in initial state.
        dispatch(appointmentsAction(null));
        AppointmentService.getAppointments(params).then((response) => {
            dispatch(appointmentsAction(response.data));
        }).catch((error) => {
            dispatch(alerts.error(error.message));
        });
    };

    function appointmentsAction(appointments) { return {type: CONSTANTS.ACTIONS.APPOINTMENT.GET.APPOINTMENTS, appointments: appointments} }
}

export function fetchSchedule(businessName, params) {
    return dispatch => {
        // Reset schedules to null so that component re renders itself in initial state.
        dispatch(scheduleAction(null));
        AppointmentService.getSchedule(businessName, params).then((response) => {
            dispatch(scheduleAction(response.data));
        }).catch((error) => {
            dispatch(alerts.error(error.message));
        });
    };

    function scheduleAction(classes) { return {type: CONSTANTS.ACTIONS.APPOINTMENT.GET.SCHEDULE, classes: classes} }
}

export function bookMemberToAppointment(appointmentId, activityId, history = {}) {
    return dispatch => {
        // Reset appointment to null so that component re renders itself in initial state.
        dispatch(bookAppointmentAction(null, false));
        dispatch({type: CONSTANTS.ACTIONS.SPINNER.SHOW});
        AppointmentService.bookMemberToAppointment(appointmentId).then((response) => {
            dispatch({type: CONSTANTS.ACTIONS.SPINNER.HIDE});
            if(response.data.success) {
                dispatch(bookAppointmentAction(response.data.appointment, true));
            } else {
                CacheService.setAppointment({id: appointmentId, activity_id: activityId});
                history.push(`/${CacheService.getToken().bname}/pos/sales`);
            }
        }).catch((error) => {
            dispatch({type: CONSTANTS.ACTIONS.SPINNER.HIDE});
            dispatch(alerts.error(error.message));
        });
    };

    function bookAppointmentAction(appointment, confirmed) {
        if(appointment) appointment.confirmed = confirmed;
        return {type: CONSTANTS.ACTIONS.APPOINTMENT.CONFIRM, appointment: appointment}
    }
}
